export default __webpack_public_path__ + "static/media/Rubik-BlackItalic.7a94cd25.ttf";